//CSS Import
import '../../css/SplashScreen.css'
import React,{Component} from 'react';
import PropTypes from 'prop-types';
import {CardActions,Card,CardText,Button} from 'react-md';
import Properties from '../../components/Properties';
import styles from '../../css/styles.css';
import { render } from 'react-dom';
import { AppProperties } from '../../common/functions';

//bug-tracker#228 Line 11

//const SplashScreen = function(props) {
class SplashScreen extends Component {
   appProperties = AppProperties();

   constructor(props){
    super(props);
    this.QuizList = this.QuizList.bind(this);
   }
    QuizList(){
        //window.location.reload();
        //window.location.href = "/quizes";
        console.log("Close");
        this.props.history.push("/");

    }
    render(){
        let text =
        this.props.isTest === 1
        ?
            (this.props.testWindowEnded)
            ?
                "Sorry! The Test is Closed!"
            :
                //Test
                (this.props.isTimerExpired == 1)
                ?
                    "Sorry! The Test Timer has Expired!"
                :
                    (this.props.hasCompleted == 1)
                    ?
                        "Congratulations! You have completed the test."
                    :
                        ""          
        :
            //Quiz
            (this.props.quizWindowEnded)
            ?
                "Sorry! The Quiz is Closed!"
            :
                (this.props.hasCompleted == 1)
                ?
                    "Congratulations! You have completed the quiz."
                :
                    ""
         ;       
        return (text !== "")
            ?

                <Card  className="md-block-centered splashScreencontainer">
                    <CardText style={{fontSize:'xx-large'}}>
                    <center><p >
                        {text}
                        <br/></p></center>
                    </CardText>
                    {
                        this.appProperties.enableLTI === true?
                        null:
                        <CardActions centered>
                            <Button flat primary swapTheming onClick={this.QuizList}>Dashboard</Button>
                        </CardActions>
                    }
                </Card>
            :
                <Card  className="md-block-centered splashScreencontainer">

                    {!this.props.allowPractice ? <div className='py-4' style={{color:"#bb0000",textAlign:"center"}}>Sorry, this quiz is currently unavailable for practice. Please request the instructor to enable practice mode for this quiz.</div>
                    :
                    <>
                    <h1 style={{color:"#bb0000",textAlign:"center"}}>
                        {"Welcome to the "+this.props.title}
                    </h1>
                
                    <CardText dangerouslySetInnerHTML={{__html: this.props.splashText}}>
                    
                    </CardText>
                    <CardActions centered>
                        <Button flat primary disabled={this.props.isLockedOut} style={this.props.isLockedOut ?styles.calciButton: null} swapTheming onClick={()=>this.props.onShowCategorySelection()}>{this.props.isLockedOut ? "Locked" : "Start"}</Button>
                    </CardActions>
                    {this.props.isLockedOut ? <center><div style={{color:'grey', marginBottom:'20px'}}><b>Note :</b> You've attempted too many times. Your assignment is now locked! Please contact your teacher.</div></center> : null }
                    </>          
                    }
                </Card>
    }
};

SplashScreen.propTypes = {
    title: PropTypes.string.isRequired,
    splashText: PropTypes.string,
};

export default SplashScreen;